var utils = require('../../utils')

import AppHeader from '../AppHeader'

export default {
  name: 'moral-sent',
  data () {
    return {
      messageManagerContent: null,
      messageOfficerContent: null,
      clicked: false
    }
  },
  computed: {
    isShopMaster () {
      return window.localStorage.getItem('is_shop_master') === '1'
    },
    isOfficer() {
      return window.localStorage.getItem('is_officer') === '1'
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    },
    goMessageSent: function () {
      this.clicked = true
      var self = this
      var data = {
        'user_id': window.localStorage.getItem('user_id'),
        'shop_id': window.localStorage.getItem('shop_id'),
        'manager_content': self.messageManagerContent,
        'officer_content': self.messageOfficerContent
      }
      var callback = function() {
        self.$router.push({ path: '/message_sent/'})
      }
      this.$store.dispatch('MESSAGE_SEND', {data: data, callback: callback})
    },
    rmEmoji: function(text, data) {
      if (data == 'manager') {
        this.messageManagerContent = utils.removeEmoji(text)
      } else if (data == 'officer') {
        this.messageOfficerContent = utils.removeEmoji(text)
      }
    },
    notInput: function() {
      if (this.messageManagerContent || this.messageOfficerContent) {
        return false
      } else {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-sent.js